import React from "react";
import PropTypes from "prop-types";

const Pill = ({ pillColor, fontColor, label, className, style }) => {
  return (
    <p
      className={`${pillColor} ${fontColor} text-center rounded-2xl px-4 cursor-default ${className}`}
      style={{ width: "fit-content", ...style }}
    >
      {label}
    </p>
  );
};

Pill.propTypes = {
  pillColor: PropTypes.string,
  fontColor: PropTypes.func,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Pill.defaultProps = {
  pillColor: "bg-black",
  fontColor: "text-white",
  className: "",
};

export default Pill;
